import Button from '@atlaskit/button';

import { createRender } from './types';

export const render = createRender(() => <Button>This is an example test button</Button>);

export default render;
